import { useKeycloak } from "@react-keycloak/web";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import gundi_logo from "../../images/gundi_logo.png";

type PrivateRouteProps = {
  children: ReactElement
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { keycloak, initialized } = useKeycloak();
  const { t } = useTranslation();

  // Wait for Keycloak to finish its check-sso before rendering anything,
  // otherwise authenticated is briefly false and triggers the login UI on every refresh.
  if (!initialized) return null;

  // Check both localStorage and keycloak.authenticated to handle session expiration
  const isLoggedIn = keycloak?.authenticated && localStorage.getItem("userAuthorized") !== null;

  const handleLogin = () => {
    if (keycloak) {
      keycloak.login();
    }
  };

  return !isLoggedIn ?
    <div className="h-[calc(100vh-115px)] flex items-center justify-center bg-very-light-gray dark:bg-off-black">
      <div className="bg-white rounded-lg shadow-xl p-8 sm:p-10 max-w-md w-full mx-4">
        {/* Gundi Logo and Name */}
        <div className="flex flex-row justify-center items-baseline mb-6">
          <img src={gundi_logo} alt="gundi logo" className="h-8" />
          <label className="ml-3 text-3xl font-bold text-black">GUNDI</label>
        </div>

        {/* Welcome Message */}
        <div className="mb-6 text-center">
          <p className="text-lg text-dark-gray">
            {t("Welcome to Gundi" as any)}
          </p>
          <p className="text-sm text-secondary-gray mt-2">
            {t("Please log in to continue" as any)}
          </p>
        </div>

        {/* Login Button */}
        <div className="mt-6">
          <button
            type="button"
            className="font-bold w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-3 bg-dark-green text-base text-white hover:bg-status-green focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-green transition-colors"
            onClick={handleLogin}
          >
            {t("Log In")}
          </button>
        </div>
      </div>
    </div> :
    children
    ;
};

export default PrivateRoute;